import { render, staticRenderFns } from "./exchange-email.vue?vue&type=template&id=49d4510c&scoped=true"
import script from "./exchange-email.vue?vue&type=script&lang=js"
export * from "./exchange-email.vue?vue&type=script&lang=js"
import style0 from "./exchange-email.vue?vue&type=style&index=0&id=49d4510c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d4510c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d4510c')) {
      api.createRecord('49d4510c', component.options)
    } else {
      api.reload('49d4510c', component.options)
    }
    module.hot.accept("./exchange-email.vue?vue&type=template&id=49d4510c&scoped=true", function () {
      api.rerender('49d4510c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/exchange-email.vue"
export default component.exports